import Validator from 'fastest-validator';

import {getEmailSchema} from './schema';

export const isEmail = (str: string) => {
  const v = new Validator();

  const check = v.compile({email: getEmailSchema()});

  return check({email: str}) === true;
};
